module.exports = __webpack_public_path__ + "img/photo.0df76558.png";